export default __webpack_public_path__ + "static/EmployerAnimation-16c526ac1619ff90b1f468801368ce1d.mp4";